import {useNuxtApp} from '#imports';

function useReadCurrentHostname(): string {
    const nuxtApp = useNuxtApp();

    if (import.meta.server) {
        return nuxtApp.ssrContext!.event.node.req.headers.host!;
    }

    return window.location.hostname;
}

function useGetCurrentDomainExtension(): string {
    const currentHost = useReadCurrentHostname();
    return currentHost?.split('.').pop()!.toLowerCase() || 'frontend';
}

function useIsCurrentDomainExtensionOneOf(domainExtensions: string[]) {
    return domainExtensions.includes(useGetCurrentDomainExtension());
}

function createCurrentHostApi() {
    return {
        getCurrentHost: useReadCurrentHostname,
        getCurrentDomainExtension: useGetCurrentDomainExtension,
        isCurrentDomainExtensionOneOf: useIsCurrentDomainExtensionOneOf,
    };
}

export {createCurrentHostApi as useCurrentHost};
